module.exports = __webpack_public_path__ + "img/thank2.bc44d34c.svg";